
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ActivateUserResponse": [
      "ActivateUserSuccessfulResponse",
      "ErrorResponse"
    ],
    "AssessmentResultData": [
      "CardioRespResult",
      "InbodyCompositionResult",
      "IndividualMotivationResult",
      "ML360Result",
      "SartResult",
      "SelfDeterminationResult",
      "SpatialPlanningResult",
      "StrengthResult",
      "TeamResilienceResult",
      "TrainersNotesResult",
      "VisualReactionResult"
    ],
    "BaseCourse": [
      "CourseInstance",
      "CourseTemplate"
    ],
    "BaseModuleDefinition": [
      "AssessmentModuleDefinition",
      "ExternalModuleDefinition",
      "ReportingModuleDefinition",
      "TrainingModuleDefinition"
    ],
    "BaseModuleInstanceConfiguration": [
      "BmpConfiguration",
      "CardioRespConfiguration",
      "FinSwimConfiguration",
      "InbodyCompositionConfiguration",
      "IndividualMotivationModuleInstanceConfiguration",
      "IpptConfiguration",
      "ML360ModuleInstanceConfiguration",
      "March20KmConfiguration",
      "SARTModuleInstanceConfiguration",
      "SelfDeterminationModuleInstanceConfiguration",
      "SocConfiguration",
      "SpatialPlanningModuleInstanceConfiguration",
      "StrengthConfiguration",
      "TeamResilienceModuleInstanceConfiguration",
      "VisualReactionModuleInstanceConfiguration",
      "WeightConfiguration"
    ],
    "BaseUser": [
      "SuperAdminUser",
      "TenantUser"
    ],
    "BasicAuthenticationResponse": [
      "BasicAuthenticationRequire2FASetupResponse",
      "BasicAuthenticationRequireOtpResponse",
      "BasicAuthenticationResetPasswordResponse",
      "BasicAuthenticationSuccessfulResponse",
      "ErrorResponse"
    ],
    "Broadcast": [
      "UserSessionBroadcast"
    ],
    "CancelInvitationPayload": [
      "CancelInvitationSuccessfulResponse",
      "ErrorResponse"
    ],
    "ChangeEmailResponse": [
      "ChangeEmailSuccessfulResponse",
      "ErrorResponse"
    ],
    "ChangePasswordResponse": [
      "ChangePasswordSuccessfulResponse",
      "ErrorResponse"
    ],
    "ConfirmEmailResponse": [
      "ConfirmEmailSuccessfulResponse",
      "ErrorResponse"
    ],
    "Course": [
      "CourseInstance",
      "CourseTemplate"
    ],
    "CreateAssessmentRunsPayload": [
      "CreateAssessmentRunsSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateCompanyPayload": [
      "CreateCompanySuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateCourseInstancePayload": [
      "CreateCourseInstanceSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateCourseTemplatePayload": [
      "CreateCourseTemplateSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateGlossaryPayload": [
      "CreateGlossarySuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateGroupPayload": [
      "CreateGroupSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateModuleInstancePayload": [
      "CreateModuleInstanceSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateProgramPayload": [
      "CreateProgramSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateSubgroupPayload": [
      "CreateSubgroupSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateUserResponse": [
      "CreateUserSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeactivateUserResponse": [
      "DeactivateUserSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteAssessmentResultPayload": [
      "DeleteAssessmentResultSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteAssessmentRunsPayload": [
      "DeleteAssessmentRunsSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteCompanyPayload": [
      "DeleteCompanySuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteCourseInstancePayload": [
      "DeleteCourseInstanceSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteCourseTemplatePayload": [
      "DeleteCourseTemplateSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteCourseTemplateSeriesPayload": [
      "DeleteCourseTemplateSeriesSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteGlossaryPayload": [
      "DeleteGlossarySuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteGroupPayload": [
      "DeleteGroupSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteModuleInstancePayload": [
      "DeleteModuleInstanceSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeletePerformanceResultPayload": [
      "DeletePerformanceResultSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteProgramPayload": [
      "DeleteProgramSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteSubgroupPayload": [
      "DeleteSubgroupSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteUserResponse": [
      "DeleteUserSuccessfulResponse",
      "ErrorResponse"
    ],
    "DownloadTemplateImportUsersPayload": [
      "DownloadTemplateImportUsersResponse",
      "ErrorResponse"
    ],
    "EnableAuthenticatorResponse": [
      "EnableAuthenticatorSuccessfulResponse",
      "ErrorResponse"
    ],
    "ExportAssessmentResultPayload": [
      "ErrorResponse",
      "ExportAssessmentResultSuccessfulResponse"
    ],
    "ExportPerformanceResultPayload": [
      "ErrorResponse",
      "ExportPerformanceResultSuccessfulResponse"
    ],
    "ExportUsersPayload": [
      "ErrorResponse",
      "ExportUsersSuccessfulResponse"
    ],
    "GenerateTrainersNotesPayload": [
      "ErrorResponse",
      "GenerateTrainersNotesSuccessfulResponse"
    ],
    "ImportAssessmentResultPayload": [
      "ErrorResponse",
      "ImportAssessmentResultSuccessfulResponse"
    ],
    "ImportPerformanceResultPayload": [
      "ErrorResponse",
      "ImportPerformanceResultSuccessfulResponse"
    ],
    "ImportUsersPayload": [
      "ErrorResponse",
      "ImportUsersSuccessfulResponse"
    ],
    "ImportUsersProgressPayload": [
      "ErrorResponse",
      "ImportUsersProgressSuccessfulResponse"
    ],
    "InviteResponse": [
      "ErrorResponse",
      "InviteSuccessfulResponse"
    ],
    "InviteeResponse": [
      "ErrorResponse",
      "InviteeSuccessResponse"
    ],
    "ModuleDefinition": [
      "AssessmentModuleDefinition",
      "ExternalModuleDefinition",
      "ReportingModuleDefinition",
      "TrainingModuleDefinition"
    ],
    "ModuleInstanceConfiguration": [
      "BmpConfiguration",
      "CardioRespConfiguration",
      "FinSwimConfiguration",
      "InbodyCompositionConfiguration",
      "IndividualMotivationModuleInstanceConfiguration",
      "IpptConfiguration",
      "ML360ModuleInstanceConfiguration",
      "March20KmConfiguration",
      "SARTModuleInstanceConfiguration",
      "SelfDeterminationModuleInstanceConfiguration",
      "SocConfiguration",
      "SpatialPlanningModuleInstanceConfiguration",
      "StrengthConfiguration",
      "TeamResilienceModuleInstanceConfiguration",
      "VisualReactionModuleInstanceConfiguration",
      "WeightConfiguration"
    ],
    "PerformanceResultData": [
      "BmpResult",
      "FinSwimResult",
      "IpptResult",
      "March20kmResult",
      "SocResult",
      "WeightResult"
    ],
    "PhysicalBaseConfiguration": [
      "BmpConfiguration",
      "CardioRespConfiguration",
      "FinSwimConfiguration",
      "InbodyCompositionConfiguration",
      "IpptConfiguration",
      "March20KmConfiguration",
      "SocConfiguration",
      "StrengthConfiguration",
      "WeightConfiguration"
    ],
    "RequestNewPasswordResponse": [
      "ErrorResponse",
      "RequestNewPasswordSuccessfulResponse"
    ],
    "ResetPasswordResponse": [
      "ErrorResponse",
      "ResetPasswordSuccessfulResponse"
    ],
    "ResponseResult": [
      "LikertScaleResult",
      "RatingScaleResult"
    ],
    "ResponseType": [
      "LikertScaleResponse",
      "RatingScaleResponse"
    ],
    "SSOConfiguration": [
      "MSALConfiguration",
      "OIDCConfiguration"
    ],
    "SignUpResponse": [
      "ErrorResponse",
      "SignUpSuccessResponse"
    ],
    "SubmitBmpResultPayload": [
      "ErrorResponse",
      "SubmitBmpResultSuccessfulResponse"
    ],
    "SubmitCardioRespResultPayload": [
      "ErrorResponse",
      "SubmitCardioRespResultSuccessfulResponse"
    ],
    "SubmitFinSwimResultPayload": [
      "ErrorResponse",
      "SubmitFinSwimResultSuccessfulResponse"
    ],
    "SubmitInbodyCompositionResultPayload": [
      "ErrorResponse",
      "SubmitInbodyCompositionResultSuccessfulResponse"
    ],
    "SubmitIndividualMotivationAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitIndividualMotivationAssessmentResultSuccessfulResponse"
    ],
    "SubmitIpptResultPayload": [
      "ErrorResponse",
      "SubmitIpptResultSuccessfulResponse"
    ],
    "SubmitML360AssessmentResultPayload": [
      "ErrorResponse",
      "SubmitML360AssessmentResultSuccessfulResponse"
    ],
    "SubmitMarch20KmResultPayload": [
      "ErrorResponse",
      "SubmitMarch20KmResultSuccessfulResponse"
    ],
    "SubmitSartAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitSartAssessmentResultSuccessfulResponse"
    ],
    "SubmitSelfDeterminationAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitSelfDeterminationAssessmentResultSuccessfulResponse"
    ],
    "SubmitSocResultPayload": [
      "ErrorResponse",
      "SubmitSocResultSuccessfulResponse"
    ],
    "SubmitSpatialPlanningAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitSpatialPlanningAssessmentResultSuccessfulResponse"
    ],
    "SubmitStrengthResultPayload": [
      "ErrorResponse",
      "SubmitStrengthResultSuccessfulResponse"
    ],
    "SubmitTeamResilienceAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitTeamResilienceAssessmentResultSuccessfulResponse"
    ],
    "SubmitTrainersNotesResultPayload": [
      "ErrorResponse",
      "SubmitTrainersNotesResultSuccessfulResponse"
    ],
    "SubmitVisualReactionAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitVisualReactionAssessmentResultSuccessfulResponse"
    ],
    "SubmitWeightResultPayload": [
      "ErrorResponse",
      "SubmitWeightResultSuccessfulResponse"
    ],
    "SwitchCompanyResponse": [
      "ErrorResponse",
      "SwitchCompanySuccessfulResponse"
    ],
    "TemplateDownloadPayload": [
      "ErrorResponse",
      "TemplateDownloadSuccessfulResponse"
    ],
    "UpdateAssessmentRunsPayload": [
      "ErrorResponse",
      "UpdateAssessmentRunsSuccessfulResponse"
    ],
    "UpdateBmpResultPayload": [
      "ErrorResponse",
      "UpdateBmpResultSuccessfulResponse"
    ],
    "UpdateCardioRespResultPayload": [
      "ErrorResponse",
      "UpdateCardioRespResultSuccessfulResponse"
    ],
    "UpdateCompanyPayload": [
      "ErrorResponse",
      "UpdateCompanySuccessfulResponse"
    ],
    "UpdateCourseInstancePayload": [
      "ErrorResponse",
      "UpdateCourseInstanceSuccessfulResponse"
    ],
    "UpdateCourseTemplatePayload": [
      "ErrorResponse",
      "UpdateCourseTemplateSuccessfulResponse"
    ],
    "UpdateFinSwimResultPayload": [
      "ErrorResponse",
      "UpdateFinSwimResultSuccessfulResponse"
    ],
    "UpdateGlossaryPayload": [
      "ErrorResponse",
      "UpdateGlossarySuccessfulResponse"
    ],
    "UpdateGroupPayload": [
      "ErrorResponse",
      "UpdateGroupSuccessfulResponse"
    ],
    "UpdateInbodyCompositionResultPayload": [
      "ErrorResponse",
      "UpdateInbodyCompositionResultSuccessfulResponse"
    ],
    "UpdateIpptResultPayload": [
      "ErrorResponse",
      "UpdateIpptResultSuccessfulResponse"
    ],
    "UpdateMarch20KmResultPayload": [
      "ErrorResponse",
      "UpdateMarch20KmResultSuccessfulResponse"
    ],
    "UpdateModuleInstancePayload": [
      "ErrorResponse",
      "UpdateModuleInstanceSuccessfulResponse"
    ],
    "UpdateProfileResponse": [
      "ErrorResponse",
      "UpdateProfileSuccessfulResponse"
    ],
    "UpdateProgramPayload": [
      "ErrorResponse",
      "UpdateProgramSuccessfulResponse"
    ],
    "UpdateSSOResponse": [
      "ErrorResponse",
      "UpdateSSOSuccessfulResponse"
    ],
    "UpdateSocResultPayload": [
      "ErrorResponse",
      "UpdateSocResultSuccessfulResponse"
    ],
    "UpdateStrengthResultPayload": [
      "ErrorResponse",
      "UpdateStrengthResultSuccessfulResponse"
    ],
    "UpdateSubgroupPayload": [
      "ErrorResponse",
      "UpdateSubgroupSuccessfulResponse"
    ],
    "UpdateTrainersNotesResultPayload": [
      "ErrorResponse",
      "UpdateTrainersNotesResultSuccessfulResponse"
    ],
    "UpdateUserConsentResponse": [
      "ErrorResponse",
      "UpdateUserConsentSuccessfulResponse"
    ],
    "UpdateUserPayload": [
      "ErrorResponse",
      "UpdateUserSuccessfulResponse"
    ],
    "UpdateWeightResultPayload": [
      "ErrorResponse",
      "UpdateWeightResultSuccessfulResponse"
    ],
    "UploadFilePayload": [
      "ErrorResponse",
      "UploadFileSuccessfulResponse"
    ],
    "User": [
      "SuperAdminUser",
      "TenantUser"
    ],
    "ValidateImportAssessmentResultPayload": [
      "ErrorResponse",
      "ValidateImportAssessmentResultSuccessfulResponse"
    ],
    "ValidateImportPerformanceResultPayload": [
      "ErrorResponse",
      "ValidateImportPerformanceResultSuccessfulResponse"
    ],
    "ValidateImportUsersPayload": [
      "ErrorResponse",
      "ValidateImportUsersSuccessfulResponse"
    ],
    "VariantSpecifics": [
      "AssessmentModuleDefinition",
      "TrainingModuleDefinition"
    ],
    "VerifyOtpResponse": [
      "ErrorResponse",
      "VerifyOtpSuccessfulResponse"
    ]
  }
};
      export default result;
    